module.exports = __webpack_public_path__ + "img/P150T_weapon_156.647a7997.png";